<div class="fh-modal" role="dialog" aria-modal="true" aria-labelledby="product-modal-title">
  <div class="fh-modal-backdrop" (click)="closed.emit()"></div>
  <div class="fh-modal-panel">
    <div class="fh-modal-head">
      <span class="line-tile" [ngClass]="tone"><i class="bi" [ngClass]="lineOf(service.businessLine).icon"></i></span>
      <div class="flex-grow-1 min-w-0">
        <div class="small text-muted-fh text-truncate">{{ lineOf(service.businessLine).label }} · {{ service.name }}</div>
        <h2 id="product-modal-title" class="h5 fw-semibold mb-0 text-truncate">
          {{ isEdit ? product!.name : 'Aggiungi prodotto' }}
        </h2>
        <div *ngIf="isEdit" class="small text-muted-fh">Prodotto #{{ product!.id }}</div>
      </div>
      <button type="button" class="icon-btn" (click)="closed.emit()" aria-label="Chiudi">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="fh-modal-body">
      <div *ngIf="!isEdit" class="segmented mb-4">
        <button type="button" [class.active]="mode === 'create'" (click)="setMode('create')">
          <i class="bi bi-plus-circle me-1"></i>Nuovo prodotto
        </button>
        <button type="button" [class.active]="mode === 'link'" (click)="setMode('link')">
          <i class="bi bi-link-45deg me-1"></i>Collega esistente
        </button>
      </div>

      <!-- Nuovo / modifica -->
      <form *ngIf="mode === 'create' || isEdit" [formGroup]="form" (ngSubmit)="submit()" class="row g-3">
        <div class="col-12">
          <label class="form-label" for="prd-name">Nome</label>
          <input id="prd-name" class="form-control" formControlName="name" placeholder="Es. Ore babysitting" />
          <span class="form-error" *ngIf="(form.get('name')?.touched || formInvalid) && form.get('name')?.invalid">
            Questo campo è obbligatorio
          </span>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="prd-type">Tipo pagamento</label>
          <select id="prd-type" class="form-select" formControlName="type">
            <option *ngFor="let type of productTypes" [ngValue]="type.value">{{ type.label }}</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="prd-stripe">Stripe ID</label>
          <input id="prd-stripe" class="form-control mono" formControlName="stripeID" placeholder="prod_…" />
        </div>
      </form>

      <!-- Collega esistente -->
      <div *ngIf="mode === 'link' && !isEdit">
        <div class="position-relative mb-3">
          <i class="bi bi-search position-absolute top-50 translate-middle-y ms-3 text-muted-fh"></i>
          <input class="form-control ps-5" type="search" [formControl]="search" placeholder="Cerca per nome del prodotto…" />
        </div>
        <div class="result-list">
          <button
            type="button"
            *ngFor="let item of results"
            class="result-item"
            [class.selected]="selected?.id === item.id"
            [disabled]="inThisService(item)"
            (click)="selected = item"
          >
            <span class="flex-grow-1 min-w-0">
              <span class="d-block fw-medium text-truncate">{{ item.name }}</span>
              <span class="d-block small text-muted-fh text-truncate">
                #{{ item.id }} · {{ productTypeLabel(item.type) }}
                <ng-container *ngIf="item.service"> · {{ item.service.name }}</ng-container>
              </span>
            </span>
            <span *ngIf="inThisService(item)" class="chip chip-success">In questo servizio</span>
            <i *ngIf="selected?.id === item.id" class="bi bi-check-circle-fill text-primary"></i>
          </button>
          <div *ngIf="!searching && !results.length" class="text-center text-muted-fh small py-4">
            Nessun prodotto trovato.
          </div>
        </div>
        <div *ngIf="selected?.service && !inThisService(selected!)" class="notice mt-3">
          <i class="bi bi-exclamation-triangle me-1"></i>
          Un prodotto appartiene a un solo servizio: verrà spostato da <b>{{ selected!.service.name }}</b> a {{ service.name }}.
          <ng-container *ngIf="selected!.service.businessLine !== service.businessLine">
            Attenzione: è di un'altra business line ({{ lineOf(selected!.service.businessLine).label }}).
          </ng-container>
        </div>
      </div>

      <div *ngIf="confirmDelete" class="notice mt-3">
        <i class="bi bi-exclamation-triangle me-1"></i>
        Il prodotto verrà eliminato.<ng-container *ngIf="priceCount"> Ha {{ priceCount }} {{ priceCount === 1 ? 'prezzo collegato' : 'prezzi collegati' }}.</ng-container>
        Premi «Conferma eliminazione» per procedere.
      </div>
      <div *ngIf="errorText" class="alert alert-danger small mt-3 mb-0">{{ errorText }}</div>
    </div>

    <div class="fh-modal-foot">
      <button *ngIf="isEdit" type="button" class="danger-link" [disabled]="saving" (click)="deleteProduct()">
        <i class="bi bi-trash3 me-1"></i>{{ confirmDelete ? 'Conferma eliminazione' : 'Elimina' }}
      </button>
      <span *ngIf="!isEdit" class="hint">Il salvataggio è immediato.</span>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-light" (click)="closed.emit()">Annulla</button>
        <button type="button" class="btn btn-primary text-light" [disabled]="saving" (click)="submit()">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          {{ isEdit ? 'Salva' : mode === 'link' ? 'Collega' : 'Crea prodotto' }}
        </button>
      </div>
    </div>
  </div>
</div>
